import styled from 'styled-components';

export const GroupSwitch = styled.div`
  display: inline-flex;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const Label = styled.label`
  position: relative;
  width: 110px;
  height: 84px;
  border: 1px solid var(--aluminium35);
  display: inline-flex;
  padding: 8px;
  border-radius: 4px;
  margin-right: 12px;
  margin-bottom: 12px;
  transition: var(--transition);

  &:last-child {
    margin-right: 0;
  }

  &.is-active {
    border-color: #0f71d4;

    .group-switch__value {
      font-weight: 600;
    }
  }

  &[disabled] {
    background: var(--aluminium10);
    border-color: var(--aluminium10);
    pointer-events: none;
  }

  @media (max-width: 767px) {
    margin-right: 6px;
  }
`;

export const Type = styled.span`
  position: absolute;
  right: 3px;
  top: -11px;
  font-size: 25px;
`;

export const Value = styled.span`
  padding-top: 20px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  line-height: 1.2em;
  color: var(--carbone80);
  flex-grow: 1;
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  transition: var(--transition);

  &:hover {
    border-color: #acb6c2;
  }
`;

export const InnerText = styled.span`
  display: flex;
  align-items: flex-end;
  height: 43px;
  overflow: hidden;
`;
